// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3gq7Q","title":"InfoRow_title__2-zTf"};